import { MultiSelectInput, Tag } from '@cxc/react-fpds-components';
import React, { useCallback } from 'react';
import { getVehicleModels } from '../../utils/IncentiveDataHelpers';
import { useAtom } from 'jotai';
import { weightClassData } from '../../state/GlobalState';
import { WeightClass } from '../../types/WeightClass';

const WeightClassDropdown = () => {
    const [selectedWeightClass, setSelectedWeightClass] = useAtom<WeightClass[]>(weightClassData);
    const [formattedSelections, setFormattedSelections] =
        React.useState<Record<string, React.JSX.Element>>();

    const handleOptionToggle = (value: WeightClass[]) => {
        const cleanedValue = value.map(({ label, value }) => ({ label, value }));
        setSelectedWeightClass(cleanedValue);
    };

    const handleClear = () => {
        setSelectedWeightClass([]);
    };

    const handleTagDelete = useCallback(
        (index: number) => {
            const selectedCopy = [...selectedWeightClass];
            selectedCopy.splice(index, 1);
            setSelectedWeightClass(selectedCopy);
        },
        [selectedWeightClass, setSelectedWeightClass],
    );

    React.useEffect(() => {
        if (Array.isArray(selectedWeightClass)) {
            const selections = selectedWeightClass.reduce(
                (
                    accumulator: Record<string, React.JSX.Element>,
                    current: WeightClass,
                    index: number,
                ) => {
                    accumulator[current.value] = (
                        <Tag
                            key={current.label}
                            title={current.label}
                            onDelete={() => handleTagDelete(index)}
                        />
                    );
                    return accumulator;
                },
                {},
            );

            setFormattedSelections(selections);
        }
    }, [handleTagDelete, selectedWeightClass]);

    return (
        <MultiSelectInput
            placeholder="All"
            options={getVehicleModels()}
            selected={formattedSelections || {}}
            onOptionSelect={handleOptionToggle}
            onClickClear={handleClear}
            labelProp={{
                label: 'Ford Model',
            }}
            size="small"
            menuHeader="select_all"
            isSearchable={false}
        />
    );
};

export default WeightClassDropdown;
